var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdoreBleu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM6.33325 5.9165C6.33325 6.60686 5.77361 7.1665 5.08325 7.1665C4.3929 7.1665 3.83325 6.60686 3.83325 5.9165C3.83325 5.22615 4.3929 4.6665 5.08325 4.6665C5.77361 4.6665 6.33325 5.22615 6.33325 5.9165ZM12.1667 5.9165C12.1667 6.60686 11.6071 7.1665 10.9167 7.1665C10.2264 7.1665 9.66675 6.60686 9.66675 5.9165C9.66675 5.22615 10.2264 4.6665 10.9167 4.6665C11.6071 4.6665 12.1667 5.22615 12.1667 5.9165ZM4 10C4.65 11.95 6.26667 13.3333 8.16667 13.3333C10.0667 13.3333 11.6833 11.95 12.3333 10H4Z",
    fill: "#3367CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdoreBleu);
export default __webpack_public_path__ + "static/media/adoreBleu.2bfa9684.svg";
export { ForwardRef as ReactComponent };